import React, { useEffect, useState } from "react";
import { checkProivderStatus, getAllProviders } from "../../../config/LiveApi";
import { useSelector } from "react-redux";
import DataTable from "../../../components/common/DataTable/DataTable";
import Spinner from "../../Spin/Spinner";

const CheckProvider = () => {
  const token = useSelector((store) => store.userReducer.token);
  const [isLoading, setIsLoading] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [statusMap, setStatusMap] = useState({});
  const [checkingMap, setCheckingMap] = useState({});

  useEffect(() => {
    const fetchAllProviders = async () => {
      try {
        const response = await getAllProviders(token);
        setTableData(response?.data?.data || []);
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchAllProviders();
  }, []);

  const handleCheckProviderStatus = async (id) => {
    setCheckingMap((prev) => ({ ...prev, [id]: true }));
    try {
      const response = await checkProivderStatus(token, id);
      const isActive = response?.status === 200;
      setStatusMap((prev) => ({
        ...prev,
        [id]: isActive ? "Healthy" : "Unhealthy",
      }));
    } catch (error) {
      console.log(error);
      setStatusMap((prev) => ({
        ...prev,
        [id]: "Unhealthy",
      }));
    } finally {
      setCheckingMap((prev) => ({ ...prev, [id]: false }));
    }
  };

  const columns = [
    {
      header: "Provider Name",
      accessor: "providerName",
      render: (row) => row.providerName || "-",
    },
    {
      header: "Organization Name",
      accessor: "orgName",
      render: (row) => row.orgName || "-",
    },
    {
      header: "Health Status",
      accessor: "healthStatus",
      render: (row) => {
        const status = statusMap[row.id];
        return <span>{status || "--"}</span>;
      },
    },
    {
      header: "Check Health Status",
      accessor: "action",
      render: (row) => (
        <button
          style={{
            backgroundColor: "#00C389",
            color: "white",
            padding: "10px",
            borderRadius: "5px",
            cursor: checkingMap[row.id] ? "not-allowed" : "pointer",
            opacity: checkingMap[row.id] ? 0.7 : 1,
            border: "none",
          }}
          onClick={() => handleCheckProviderStatus(row.id)}
          disabled={checkingMap[row.id]}
        >
          {checkingMap[row.id] ? "Checking..." : "Check"}
        </button>
      ),
    },
  ];

  return (
    <>
      <div className="main-heading">
        <h2>Check Provider Status</h2>
        {isLoading ? (
          <Spinner />
        ) : (
          <DataTable
            columns={columns}
            data={tableData}
            emptyMessage="No providers found."
          />
        )}
      </div>
    </>
  );
};

export default CheckProvider;
